
export enum CapacityTableStatusEnum {
    empty = 1,
    hasOrder,
}
      